<template>
   <div class="page-deliver-todo">
      <div class="pg-breadcrumb">
         <div class="breadcrumb-item em">同城配送</div>
         <div class="breadcrumb-item">交收記錄(全部)</div>
      </div>
      <div class="card-block">
         <Form inline class="pg-form-inline form-input-wrap">

            <FormItem>
               <Select size="small" placeholder="取件地方" v-model="form.arrive" clearable>
                  <Option :value="item.ReceivingID" v-for="(item, index) in pickAddress"
                          :key="item.ReceivingID">({{ item.cainiao_match }}) {{ item.ReceivingName }}
                  </Option>
               </Select>
            </FormItem>

            <FormItem>
               <Select size="small" placeholder="貨件狀態" @on-change="changeStatus" v-model="form.status" clearable>
                  <Option value="-1">全部</Option>
                  <Option value="2">待交件</Option>
                  <Option value="3">到店/櫃</Option>
                  <Option value="4">已簽收</Option>
               </Select>
            </FormItem>

            <FormItem>
               <Input size="small" placeholder="快遞單號" clearable v-model="form.odd_numbers"
                      @keyup.enter.native="handleSearch"></Input>
            </FormItem>
            <FormItem>
               <Input size="small" placeholder="客戶名稱" clearable v-model="form.username"
                      @keyup.enter.native="handleSearch"></Input>
            </FormItem>
            <FormItem>
               <Input size="small" placeholder="手機號碼" clearable v-model="form.phone"
                      @keyup.enter.native="handleSearch"></Input>
            </FormItem>
            <!--<FormItem style="display: none">
               <Input size="small" placeholder="袋號" clearable v-model="form.sack_number"
                      @keyup.enter.native="handleSearch"></Input>
            </FormItem>-->
            <FormItem>
               <div class="pg-btn-wrap">
                  <div class="pg-btn style1" @click="handleSearch">搜索</div>
               </div>
            </FormItem>
         </Form>

         <!-- </div> -->

         <!-- <div class="card-block"> -->
         <Form inline class="pg-form-inline">
            <FormItem style="display: none">
               <Select size="large" placeholder="操作人" v-model="form.admin_id" style="width:100%">
                  <Option :value="item.user_id" v-for="(item, index) in pickAdmin"
                          :key="item.user_id">{{ item.username }} ({{ item.realname }})
                  </Option>
               </Select>
            </FormItem>

            <FormItem>
               <DatePicker class="no-suffix" type="datetime" size="small" clearable
                           placeholder="入件開始日期" value-format="yyyy-MM-dd hh:mm:ss" style="width: 100%;"
                           :editable="false" v-model="form.start_time"></DatePicker>
            </FormItem>

            <FormItem>-</FormItem>

            <FormItem>
               <DatePicker class="no-suffix" type="datetime" size="small" clearable
                           placeholder="入件結束日期" value-format="yyyy-MM-dd hh:mm:ss" style="width: 100%;"
                           :editable="false" v-model="form.end_time"></DatePicker>
            </FormItem>

            <FormItem>
               <div class="pg-btn-wrap">
                  <div class="pg-btn style2" @click="handleCheck()">導出 交收記錄 (全部)</div>
               </div>
            </FormItem>
         </Form>
      </div>

      <div class="card-block pd-bt">

         <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
            <el-tab-pane label="全部" name="-1"></el-tab-pane>
            <el-tab-pane label="待交收, 到店/櫃" name="2"></el-tab-pane>
            <el-tab-pane label="到店/櫃" name="3"></el-tab-pane>
            <el-tab-pane label="已簽收" name="4"></el-tab-pane>

            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
               <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
               <div class="loading-text">Loading</div>
            </Spin>

            <Table size="small"
                   :row-class-name="rowClassName"
                   border
                   no-data-text="暫無數據"
                   :columns="table.column"
                   :data="table.data">

               <template slot-scope="{ row, index }" slot="odd_numbers">
                  <div class="avatar-box">
                     <a class="pg-btn" @click="handleViewOrder(index)">{{ row.odd_numbers }}</a>
                  </div>
               </template>

               <template slot-scope="{ row, index }" slot="status">
                  <span v-if="row.status == 0">待交件</span>
                  <span v-else-if="row.status == 1">運送中</span>
                  <span v-else-if="row.status == 3">到店/櫃</span>
                  <span v-else-if="row.status == 4">客戶簽收</span>
               </template>

               <template slot-scope="{ row, index }" slot="action">
                  <div class="pg-btn-wrap">
                     <div class="pg-btn style3" @click="handleEdit(row)" v-if="row.status < 3">【改】</div>
                  </div>
                  <br>
                  <div class="pg-btn-wrap">
                     <div class="pg-btn style2" @click="handlePrintCode(row)">【印】</div>
                  </div>
               </template>
            </Table>

            <div class="pg-pagger">
               <Row>
                  <Col span="11" class="pagger-left">
                     <div class="pagger-total">總共 {{ totalCount }} 條記錄</div>
                  </Col>
                  <Col span="13" class="pagger-right">
                     <div>
                        <div class="pagger-sizer">
                           <span>每頁</span>
                           <Select v-model="curPageSize" size="small" placeholder="數量"
                                   @on-change="handlePageSizeChange">
                              <Option :value="10">10</Option>
                              <Option :value="20">20</Option>
                              <Option :value="30">30</Option>
                              <Option :value="40">40</Option>
                              <Option :value="50">50</Option>
                           </Select>
                        </div>

                        <Page size="small"
                              :current="pageIndex"
                              :page-size="curPageSize"
                              :total="totalCount"
                              @on-change="handlePageChange">
                        </Page>
                     </div>
                  </Col>
               </Row>
            </div>
         </el-tabs>
      </div>

      <Modal v-model="isShowModalSign_goods"
             title="查詢快件"
             width="1200"
             :footer-hide="true"
             @on-cancel="handleModalSignClose_goods">
         <div class="modal-cont">
            <Spin fix class="pg-sub-loading" v-if="isSubmitingLog">
               <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
               <div class="loading-text">Loading</div>
            </Spin>

            <div style="font-weight:bold">快遞信息</div>
            <br>
            <Table no-data-text="" :columns="table1.column" :data="table1.data"></Table>
            <Table no-data-text="" :columns="table1.column1" :data="table1.data1"></Table>
            <Table no-data-text="" :columns="table1.column2" :data="table1.data2"></Table>
            <Table no-data-text="" :columns="table1.column3" :data="table1.data3">
               <template slot-scope="{row,index}" slot="status">
                  <span v-if="row.status == 0">珠海倉庫-待出庫</span>
                  <span v-else-if="row.status == 1">珠海倉庫-已出庫</span>
                  <span v-else-if="row.status == 2">澳門倉庫-配送中</span>
                  <span v-else-if="row.status == 3">澳門門店/智能櫃-未簽收</span>
                  <span v-else-if="row.status == 4">澳門門店/智能櫃-已簽收</span>
               </template>
            </Table>
            <Table no-data-text="" :columns="table1.column4" :data="table1.data4"></Table>
            <Table no-data-text="" :columns="table1.column5" :data="table1.data5"></Table>
            <br><br>
            <div style="font-weight:bold">物流信息</div>
            <br>
            <div class="step-wrap" v-if="detail && detail.length">
               <div class="step-item clearfix" v-for="(item, index) in detail" :key="item.id">
                  <div class="left">
                     <div class="l-date">
                        <span>{{ item.date }}</span>
                        <span>{{ item.week }}</span>
                     </div>
                     <div class="l-time">{{ item.time }}</div>
                  </div>
                  <div class="right">
                     <div class="r-address">{{ item.describe }} , 操作人：{{ item.userinfos }}</div>
                  </div>
               </div>
            </div>

            <div class="data-null" v-else>
               <div>暫無數據</div>
            </div>
         </div>
      </Modal>
   </div>
</template>

<script>
import axios from 'axios';
import Store from '../../../assets/js/store.js';

export default {
   data() {
      return {
         activeName: '-1',
         macao_originating: 1,
         theme1: 'light',
         sc_name: '',
         sc_id: '',
         sc_user_id: '',
         sc_store_id: '',
         sc_balance: '',
         pdfUrl: '',
         pageIndex: 1,
         curPageSize: 10,
         totalCount: 1,
         pageInput: '',
         pickAdmin: [],
         pickAddress: [],
         form: {
            admin_id: Store.fetch().parent_id,
            arrive: '',
            sack_number: '',
            odd_numbers: '',
            start_time: '',
            end_time: '',
            status: -1,
            phone: '',
            name: '',
         },
         isSubmiting: false,
         isShowModalSign_goods: false,
         isSubmitingLog: false,
         table: {
            column: [
               {
                  title: '操作',
                  slot: 'action',
                  align: 'center',
                  minWidth: 100
               },
               {
                  title: '貨物位置',
                  key: 'receivingName',
                  align: 'center',
                  sortable: true,
                  minWidth: 150
               },
               {
                  title: '出貨單號',
                  key: 'odd_numbers',
                  slot: 'odd_numbers',
                  align: 'center',
                  sortable: true,
                  minWidth: 280
               },
               {
                  title: '電話號碼',
                  key: 'recipient_phone',
                  align: 'center',
                  sortable: true,
                  minWidth: 150
               },
               {
                  title: '入件日期',
                  key: 'created_at',
                  align: 'center',
                  sortable: true,
                  minWidth: 150
               },
               {
                  title: 'KG',
                  key: 'weight',
                  align: 'center',
                  sortable: true,
                  minWidth: 80
               },
               {
                  title: '到付($)',
                  key: 'freight_collect',
                  align: 'center',
                  sortable: true,
                  minWidth: 80
               },
               {
                  title: '貨物狀態',
                  key: 'status',
                  align: 'center',
                  slot: 'status',
                  sortable: true,
                  minWidth: 100
               },
               {
                  title: '收費方式',
                  key: 'type',
                  align: 'center',
                  sortable: true,
                  minWidth: 100
               },

            ],
            data: []
         },
         table1: {
            column: [
               {
                  title: '快遞單號',
                  key: 'order',
                  align: 'center',
                  minWidth: 80
               },
               {
                  title: '客戶電話',
                  key: 'phone',
                  align: 'center',
                  minWidth: 80
               },
               {
                  title: '客戶名稱',
                  key: 'username',
                  align: 'center',
                  minWidth: 80
               },
            ],
            column1: [
               {
                  title: '重量',
                  key: 'weight',
                  align: 'center',
                  minWidth: 100
               },
               {
                  title: '尺寸',
                  key: 'size_sum',
                  align: 'center',
                  minWidth: 100
               },
               {
                  title: '提貨櫃點',
                  key: 'store',
                  align: 'center',
                  minWidth: 100
               },
            ],
            column2: [
               {
                  title: '快件明細',
                  key: 'detailed',
                  align: 'center',
                  minWidth: 100
               },
               {
                  title: '異常件',
                  key: 'abnormal',
                  align: 'center',
                  minWidth: 100
               },
               {
                  title: '出庫袋號',
                  key: 'sack_number',
                  align: 'center',
                  minWidth: 100
               },
            ],
            column3: [
               {
                  title: '最新貨態',
                  slot: 'status',
                  align: 'center',
                  minWidth: 100
               },
               {
                  title: '更新時間',
                  key: 'created_time',
                  align: 'center',
                  minWidth: 100
               },
               {
                  title: '貨架號',
                  key: 'shelves',
                  align: 'center',
                  minWidth: 100
               },
            ],
            column4: [
               {
                  title: '代收費',
                  key: 'amount',
                  align: 'center',
                  minWidth: 100
               },
               {
                  title: '附加費',
                  key: 'surcharge_price',
                  align: 'center',
                  minWidth: 100
               },
               {
                  title: '到附運費',
                  key: 'freight_collect',
                  align: 'center',
                  minWidth: 100
               },
            ],
            column5: [
               {
                  title: '超期費',
                  key: 'outTime_price',
                  align: 'center',
                  minWidth: 100
               },
               {
                  title: '合計費用',
                  key: 'total_price',
                  align: 'center',
                  minWidth: 100
               },
            ],
            data: [],
            data1: [],
            data2: [],
            data3: [],
            data4: [],
            data5: [],
         },
         detail: [],
      };
   },
   created() {
      this.getPickAdmin();
      this.getPickAddress();
   },
   mounted() {
      let logInfo = localStorage.getItem('jyb_logInfo') ? JSON.parse(localStorage.getItem('jyb_logInfo')) : {};
      if (logInfo.userparent != null) {
         this.sc_name = logInfo.userparent.mark;
         this.sc_id = logInfo.userparent.id;
         this.sc_balance = logInfo.userparent.balance;
         this.sc_user_id = logInfo.user_id;
         this.sc_store_id = logInfo.store_id;
      }
      this.getList(this.activeName, 1, 10);
   },
   activated() {
      this.getPickAdmin();
      this.getPickAddress();
      let logInfo = localStorage.getItem('jyb_logInfo') ? JSON.parse(localStorage.getItem('jyb_logInfo')) : {};
      if (logInfo.userparent != null) {
         this.sc_name = logInfo.userparent.mark;
         this.sc_id = logInfo.userparent.id;
         this.sc_balance = logInfo.userparent.balance;
         this.sc_user_id = logInfo.user_id;
         this.sc_store_id = logInfo.store_id;
      }
      this.getList(this.activeName);
   },
   methods: {
      handleModalSignClose_goods() {
         this.isShowModalSign_goods = false;
      },
      handleViewOrder(index) {
         this.isShowModalSign_goods = true;
         this.isSubmitingLog = true;
         let tableData = this.table.data;

         this.$Rq.requestAuth({
            url: this.$Api.all_search,
            method: 'get',
            data: {
               order: tableData[index].odd_numbers
            }
         }).then((res) => {
            this.isSubmitingLog = false;
            let tempArr = [];
            let tempArr1 = [];
            let tempArr2 = [];
            let tempArr3 = [];
            let tempArr4 = [];
            let tempArr5 = [];
            let resData = res.data;

            if (res.code == 0) {
               for (let i = 0; i < resData.data.length; i++) {
                  tempArr.push({
                     order: resData.data[i].order,
                     username: resData.data[i].username,
                     phone: resData.data[i].phone,
                  });

                  tempArr1.push({
                     weight: resData.data[i].weight,
                     size_sum: resData.data[i].long + 'x' + resData.data[i].width + 'x' + resData.data[i].height,
                     store: resData.data[i].store == null ? '- - -' : resData.data[i].store.ReceivingName,
                  });

                  tempArr2.push({
                     sack_number: resData.data[i].sack_number,
                     detailed: resData.data[i].detailed == null ? '- - -' : resData.data[i].detailed.name,
                     abnormal: resData.data[i].abnormal == 0 ? '否' : '是',
                  });

                  tempArr3.push({
                     shelves: resData.data[i].shelves == null ? '- - -' : resData.data[i].shelves.code,
                     status: resData.data[i].status,
                     created_time: resData.data[i].created_time,
                  });

                  tempArr4.push({
                     amount: resData.data[i].amount,
                     surcharge_price: resData.data[i].surcharge_price,
                     freight_collect: resData.data[i].freight_collect,
                  });

                  tempArr5.push({
                     outTime_price: resData.data[i].outTime_price,
                     total_price: Number(resData.data[i].surcharge_price) + Number(resData.data[i].outTime_price) + Number(resData.data[i].freight_collect) + Number(resData.data[i].amount),
                  });
               }
               this.table1.data = tempArr;
               this.table1.data1 = tempArr1;
               this.table1.data2 = tempArr2;
               this.table1.data3 = tempArr3;
               this.table1.data4 = tempArr4;
               this.table1.data5 = tempArr5;
            }
         }).catch((err) => {
            this.isSubmitingLog = false;
         });

         this.isSubmitingLog = true;
         this.$Rq.requestAuth({
            url: this.$Api.logisticsInfo + '/' + tableData[index].odd_numbers,
            method: 'get',
            data: {}
         }).then((res) => {
            this.isSubmitingLog = false;
            if (Number(res.code) == 0) {
               let resData = res.data;
               let tempArr = [];
               let userinfo;

               for (let j = 0; j < resData.length; j++) {
                  let datetime = this.getDateTime(resData[j].created_at);

                  if (resData[j].userinfos == null) {
                     if (resData[j].remarks.match(/[\u606d\u559c\u60a8]/g)) {
                        userinfo = '用戶線上支付';
                     } else {
                        if (resData[i].admin_name != null) {
                           userinfo = resData[i].admin_name;
                        } else {
                           userinfo = '智能櫃派送員';
                        }
                     }
                  } else {
                     userinfo = resData[j].userinfos.username;
                  }

                  tempArr.push({
                     userinfos: userinfo,
                     id: resData[j].id,
                     date: datetime.date,
                     week: datetime.week,
                     time: datetime.time,
                     describe: resData[j].remarks
                  });
               }

               this.detail = tempArr;
            }
         }).catch((err) => {
            this.isSubmitingLog = false;
         });
      },
      getDateTime(datetime) {
         let date = new Date(datetime);
         let year = date.getFullYear();
         let month = date.getMonth() + 1;
         let day = date.getDate();
         let hour = date.getHours();
         let minute = date.getMinutes();
         let second = date.getSeconds();
         let week = date.getDay();
         let weekList = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

         return {
            date: `${this.formateNum_log(year)}-${this.formateNum_log(month)}-${this.formateNum_log(day)}`,
            time: `${this.formateNum_log(hour)}:${this.formateNum_log(minute)}:${this.formateNum_log(second)}`,
            week: weekList[week]
         };
      },

      formateNum_log(num) {
         return num > 9 ? num : '0' + num;
      },
      getPickAddress() {
         this.$Rq.requestAuth({
            url: this.$Api.pickAddress,
            method: 'get',
            data: {
               company_id: 1,
            }
         }).then((res) => {
            if (res.code == 0) {
               this.pickAddress = res.data.data;
            }
         });
      },
      rowClassName(row, index) {
         if (row.status === 1) {
            return 'status-one';
         } else if (row.status === 2) {
            return 'status-two';
         } else if (row.status === 3) {
            return 'status-three';
         } else if (row.status === 4) {
            return 'status-four';
         }
         return '';
      },
      formatDate(datetime) {
         if (!datetime) return '';

         let dateTime = new Date(datetime);
         let year = dateTime.getFullYear();
         let month = dateTime.getMonth() + 1;
         let date = dateTime.getDate();
         let hour = dateTime.getHours();
         let minute = dateTime.getMinutes();
         let second = dateTime.getSeconds();
         let milliseconds = dateTime.getMilliseconds();
         return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
      },
      formatNum(num) {
         return num < 10 ? '0' + num : num;
      },
      getPickAdmin() {
         this.$Rq.requestAuth({
            url: this.$Api.pickAdmin,
            method: 'post'
         }).then((res) => {
            if (res.code == 0) {
               this.pickAdmin = res.data.data;
            }
         });
      },
      handleClick(tab, event) {
         console.log(tab)
         this.form.status = this.activeName
         this.getList(this.activeName, 1, 10);
      },

      changeStatus() {
         this.activeName = this.form.status
         this.getList()
      },
      getList(status_active, offset, limit) {

         let form = this.form;
         this.isSubmiting = true;
         this.$Rq.requestAuth({
            url: this.$Api.samecityList_new,
            method: 'get',
            data: {
               offset: (this.pageIndex - 1) * this.curPageSize,
               limit: this.curPageSize,
               status: form.status,
               order: form.odd_numbers,
               order_parent: 11,
               phone: form.phone,
               arrive: form.arrive,
               start_time: this.formatDate(form.start_time),
               end_time: this.formatDate(form.end_time)
            }
         }).then((res) => {
            this.isSubmiting = false;
            if (res.code == 0) {
               console.log(res.data)
               let type_name;
               let tempArr = [];
               let resData = res.data.data;

               for (let i = 0; i < resData.length; i++) {

                  tempArr.push({
                     id: resData[i].id,
                     recipient_contacts: resData[i].recipient_contacts,
                     created_at: resData[i].order_time,
                     odd_numbers: resData[i].order_number,
                     // count: resData[i].count,
                     weight: resData[i].weight,
                     type: resData[i].type,
                     remarks: resData[i].status_remark,
                     arrive: resData[i].arrive,
                     // arrive_type: resData[i].arrive_type,
                     receivingName: resData[i].store_name ? resData[i].store_name : '無',
                     status: resData[i].status,
                     // actor: resData[i].admininfo.realname,
                     recipient_phone: resData[i].user_phone,
                     freight_collect: resData[i].freight_collect,
                  });
               }

               this.totalCount = res.data.count;
               this.table.data = tempArr;
            }else {
               this.table.data = []
            }
         }).catch((err) => {
            this.isSubmiting = false;
         });
      },
      handleSearch() {
         this.pageIndex = 1;
         this.activeName = '-1';
         this.getList(this.form.status, 1, 10);
      },

      handleCheck() {
         let form = this.form;
         if (form.start_time === '') {
            this.$Utils.showTipInfo('請輸入入件開始時間');
            return;
         }
         if (form.end_time === '') {
            this.$Utils.showTipInfo('請輸入入件結束時間');
            return;
         }
         this.handleExport();
      },

      handleEdit(item) {
         this.$router.push({path: '/samecityScaninEdit?id=' + item.id});
         // let link = this.$router.resolve({path: '/samecityScaninEdit?id=' + item.id});
         // window.open(link.href, '_blank');
      },

      handleExport() {
         let token = localStorage.getItem('jyb_token');
         let logInfo = localStorage.getItem('jyb_logInfo') ? JSON.parse(localStorage.getItem('jyb_logInfo')) : {};
         let adminuser;

         if (logInfo.userparent.id == null || logInfo.userparent.id == 0) {
            this.$Utils.showTipInfo("該商家用戶錯誤");
         } else {
            adminuser = logInfo.userparent.id;
         }

         let form = this.form;
         let params = {
            name: form.username == undefined ? '' : form.username,
            phone: form.phone == undefined ? '' : form.phone,
            type: form.type == undefined ? '' : form.type,
            status: form.status == undefined ? '' : form.status,
            odd_numbers: form.odd_numbers == undefined ? '' : form.odd_numbers,
            arrive: form.arrive == undefined ? '' : form.arrive,
            parent_id: adminuser,
            zh_outadmin: form.admin_id == undefined ? '' : form.admin_id,
            start_time: this.formatDate(form.start_time),
            end_time: this.formatDate(form.end_time),
         };

         let formatParams = this.$Utils.formateObjToParamStr(params);
         console.log(formatParams);
         window.open(`${this.$Api.samecityListExcel_new}?${formatParams}`, '_blank');
         this.getList(form.status);
      },
      handlePrintCode(row) {
         let type_number;

         let params = {
            type: row.type,
            arrive: row.arrive,
            weight: row.weight,
            courier: '',
            courier_tel: '',
            odd_numbers: row.odd_numbers,
            recipient_contacts: row.recipient_contacts,
            recipient_phone: row.recipient_phone,
            freight_collect: Number(row.freight_collect) ? Number(row.freight_collect) : 0,
            parent_id: this.sc_id,
            store_id: this.sc_store_id,
            user_id: this.sc_user_id,
            remarks: row.remarks,
         };
         this.pdfUrl = this.$Api.samecityorderprint + '?' + this.$Utils.formateObjToParamStr(params);
         window.open(this.pdfUrl);
      },
      handlePageSizeChange(value) {
         this.pageIndex = 1;
         this.getList(this.activeName);
      },
      handlePageInput() {
         let value = ('' + this.pageInput).replace(/\D/g, '');
         let pageCount = Math.ceil(this.totalCount / this.curPageSize);
         if (value > pageCount) {
            value = pageCount;
         }
         this.pageInput = value;
      },
      handlePageEnter() {
         if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
         if (this.pageInput == 0) {
            this.pageInput = 1;
         }
         this.pageInput = parseInt(this.pageInput);
         this.pageIndex = this.pageInput;
         this.getList(this.activeName);
      },
      handlePageChange(value) {
         this.pageIndex = value;
         this.getList(this.activeName);
      }
   }
};
</script>
<style>
.ivu-table .status-one td {
   background-color: rgba(0, 255, 0, 0.3);
   color: #fff;
}

.ivu-table .status-two td {
   background-color: rgba(0, 255, 0, 0.3);
   color: #fff;
}

.ivu-table .status-three td {
   background-color: rgba(255, 255, 0, 0.3);
   color: #fff;
}

.ivu-table .status-four td {
   background-color: rgba(255, 0, 0, 0.3);
   color: #fff;
}
/deep/.el-tabs__content {
   overflow: inherit;
}
</style>

<style lang="scss" scoped>
@import "samecityList.scss";
</style>
